import React, { useEffect, useRef, useState } from "react";
import { ajouterConge } from "../../Services/Pointeuse/CongeApi";
import { t } from "i18next";
import swal from "sweetalert";
import { getUsersByCode } from "../../Services/Pointeuse/UsersApi";
import { addAutorisation } from "../../Services/Pointeuse/AutorisationApi";

function AddAutorisation(props) {
  const myRefDelete = useRef(null);

  const [users, setUsers] = useState([]);
  const [user, setUser] = useState(null);
  const [userId, setUserId] = useState("");
  const [date, setDate] = useState("");
  const [nbHeure, setNbHeure] = useState("");
  const [heure_debut, setHeure_debut] = useState("");

  const [objet, setObjet] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    getUsersByCode().then((res) => {
      const list = res?.data || [];
      const currentId = localStorage.getItem("id");
      const findConnecte = list.find(
        (u) => parseInt(u.id) === parseInt(currentId)
      );
      setUser(findConnecte);
      if (findConnecte && findConnecte.role !== "admin") {
        setUserId(findConnecte.id);
      } else {
        setUsers(list);
      }
    });
  }, []);

  const handleSave = () => {
    if (!userId || !date || !nbHeure || !objet||!heure_debut) {
      swal(t("Veuillez remplir tous les champs obligatoires"), "", "warning");
      return;
    }

    if (parseFloat(nbHeure) > 2) {
      swal(t("Le nombre d'heures ne peut pas dépasser 2h"), "", "warning");
      return;
    }


    const autorisationObj = {
      code_generated: localStorage.getItem('code_generated'),
      user_code_id: userId,
      date,
      heure_debut: heure_debut,
      nb_heure: nbHeure,
      objet: objet,
      type: 'demande',
      etat: 0,
      description,
    };

    swal({
      title: t("Voulez-vous vraiment créer cette autorisation ?"),
      icon: "warning",
      buttons: {
        cancel: t("Annuler"),
        confirm: {
          text: t("Confirmer"),
          value: true,
        },
      },
      dangerMode: true,
    }).then((willSave) => {
      if (willSave) {
        addAutorisation(autorisationObj)
          .then((res) => {
            swal(t("Autorisation créée avec succès"), "", "success");
            resetForm();
            myRefDelete.current.click();
            props.getData && props.getData();
          })
          .catch((err) => {
            swal(t("Erreur lors de la création"), "", "error");
            console.error(err);
          });
      }
    });
  };

  const resetForm = () => {
    setUserId("");
    setDate("");
    setNbHeure("");
    setObjet("");
    setDescription("");
  };

  return (
    <div
      className="modal fade"
      id="addCongeModal"
      tabIndex={-1}
      role="dialog"
      aria-labelledby="addCongeModalTitle"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          {/* Header */}
          <div className="modal-header">
            <h5 className="modal-title">{t("Ajouter autorisation")}</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>

          {/* Body */}
          <div className="modal-body">
            {user && user.role === "admin" && (
              <div className="form-group">
                <label>
                  {t("Collaborateur")} <span className="text-danger">*</span>
                </label>
                <select
                  onChange={(e) => setUserId(e.target.value)}
                  className="form-control"
                  value={userId}
                >
                  <option value="">{t("Choisir un collaborateur")}</option>
                  {users.map((el) => (
                    <option key={el.id} value={el.id}>
                      {el.nom} {el.prenom}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <div className="form-row">
              <div className="form-group col-md-12">
                <label>
                  {t("Date")} <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  className="form-control"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                />
              </div>
              <div className="form-group col-md-12">
                <label>
                  {t("Heure de début")} <span className="text-danger">*</span>
                </label>
                <input
                  type="time"
                  className="form-control"
                  value={heure_debut}
                  onChange={(e) => setHeure_debut(e.target.value)}
                />
              </div>
              <div className="form-group col-md-12">
                <label>
                  {t("Nombre d'heures")} <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  className="form-control"
                  max={2}
                  value={nbHeure}
                  onChange={(e) => setNbHeure(e.target.value)}
                />
              </div>
            </div>

            <div className="form-group">
              <label>
                {t("Objet")} <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={objet}
                onChange={(e) => setObjet(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>{t("Description")}</label>
              <textarea
                className="form-control"
                rows={2}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          </div>

          {/* Footer */}
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
              ref={myRefDelete}
            >
              {t("Annuler")}
            </button>
            <button type="button" className="btn btn-primary" onClick={handleSave}>
              {t("Ajouter")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddAutorisation;
